<template>
  <div class="mainContent">
    <h1>{{$t('statement.brandIntroduction')}}</h1>
    <div class="banner"><img :src="image"></div>
    <h3 class="underline">
      <p class="secondTitle">
        {{$t('statement.brandIntroduction')}}
      </p>
    </h3>
    <div class="mainText clearfix">
      <div class="text fl">
        <p>
          棒约翰创始人约翰.施耐德 (John Schnatter)高中期间在美国印第安纳洲杰斐逊维尔一家比萨店打工时就意识到，比萨连锁店都缺少某种东西，就是将高品质的传统比萨直接送到客户门前。他的梦想就是有一天开一家比萨店，填补这一空白。
          <br>1983年，约翰.施耐德(John Schnatter )送完最后一块校园比萨，带着波乐洲立大学商业学位回到了印第安纳洲杰斐逊维尔。22岁的他将父亲经营的小酒馆(Mick’s Lounge)杂物间清理干净，卖掉了心爱的1972 Z28 Camaro汽车，购买了价值1,600美元的二手餐厅设备，从吧台后面开始了比萨外卖业务。
          <br>1984年，第一家棒约翰比萨店开业。迄今为止，一直秉承“最好的馅料，最好的比萨“这一品牌承诺。棒约翰被公认为比萨行业的品质领导者，全球范围内有超过4,000家直营或品牌加盟店。
        </p>

        <b>Hand-Tossed Original Crust 传统手工饼底</b>
        <p>
          好的披萨来自好的饼底。选用高蛋白质面粉和纯净水和面的面团（绝不使用冷冻面团）新鲜配送至店内，经自然发酵以达到最佳口感，经焙烤制成韧性十足、独具风味的饼底。（配合棒约翰特制的蒜香酱，口味愈发完美！）
        </p>

        <b>All-Natural Sauce 新鲜纯天然酱料</b>
        <p>
          棒约翰多种令人赞叹的馅料中包含的新鲜纯天然番茄酱均由加利福尼亚山谷肥沃土壤和充足阳光下生长的优质番茄制作而成。从新鲜采摘到装罐仅仅不到6小时，绝不添加水份，只加入全天然成分和特制香料。整个制作过程均在最短的时间和最合适的温度下完成以保持番茄新鲜的口感，口口美味！
        </p>

        <b>Fresh Vegetables 新鲜蔬菜</b>
        <p>
          始终选用最新鲜的蔬菜确保营养和口感，绝不采用真空包装、预先切好的蔬菜。<br>青椒和洋葱均在当地市场购买，店内精心处理，确保鲜脆口感。<br>精选来自西班牙优质种植园的橄榄。<br>独具风味的意大利小蘑菇不容错过！
        </p>

        <b>Real Meats真材实料的肉类</b>
        <p>忠于选用真正高质量的肉类。牛肉和香肠均真材实料，由100%纯牛肉和猪肉混合特殊调味料制成。烹饪后口感丰富，令人垂涎。</p>

        <b>Signature Cheese 经典招牌芝士</b>
        <p>棒约翰的经典招牌芝士不容错过！柔和细腻，滋味纯正，大幅提升比萨口味。</p>
        <!--<p>北京棒约翰餐饮发展有限公司于2018年12月正式开放加盟，负责美国papajohn's在中国华北、东北、西北等地区直营及加盟业务。时至今日，棒约翰品牌已在全国成功地开出了300多家餐厅，此外还在计划以每年近30家的速度拓展。</p>-->
      </div>
    </div>
  </div>
</template>
<script>
const image = require('@/assets/image/info/6.jpg');

export default {
  name: 'root-brand',
  data() {
    return {
      image,
    };
  },
};
</script>
<style scoped lang="scss">
.mainborder {
  border: solid 1px #ccc;
}
h1 {
  padding:0 10px 10px;
}
.mainContent {
  .text p {
    line-height: 15px;
    font-size: 12px;
    color: #333;
    margin: 3px 0 8px 0;
  }
}
.mainTitle {
  margin: 18px 14px 23px;
  padding-left: 20px;
  background: none 0 -29px no-repeat;
  font-weight: normal;
  line-height: 18px;
  font-size: 17px;
  color: #414141;
  float: left;
}
.banner {
  // width: 687px;
  position: relative;
  margin-bottom: 20px;
  /* left: 5px; */
  // margin-left: 5px;
}
.banner img {
  margin: 0;
  padding: 0;
  display: block;
  width: 100%;
}
.underline {
  height: 30px;
  line-height: 100%;
  border-bottom: 2px solid #037b41;
  position: relative;
  margin-bottom: 10px;
}
.mainText {
  padding: 8px;
}
</style>
